import { render, staticRenderFns } from "./Icons.vue?vue&type=template&id=38f4f87e&functional=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

component.options.__file = "Icons.vue"
export default component.exports